module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "vi",
      "id": "pg_vi",
      "role": "doc-pagebreak"
    }
  }, [_c('h1', {
    staticClass: "FMHF",
    attrs: {
      "id": "cont"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "ePub_ePub-SC"
  }, [_vm._v("CONTENTS")])])])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CFMH",
    attrs: {
      "id": "c_for"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('li', {
    staticClass: "CFMAU"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bill Richardson")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("  1.  College Residency, Race, and Reaction: Before 1996")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_vm._v("  2.  2001–2010 State DREAM Acts and Litigation")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_vm._v("  3.  The DREAM Act in Congress and Federal Developments")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4.  The Aftermath of the DREAM Act Defeats, State Developments")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5.  The DREAM Act and Prosecutorial Discretion: The Birth of DACA")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6.  Undocumented Lawyers, DACA, and Occupational Licensing")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7.  The 2016 Election of Donald Trump, the Rescission of DACA, and Its Aftermath")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Awakening from the DREAM")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMHF",
    attrs: {
      "id": "c_ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_app1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Appendix 1. State Laws Allowing Undocumented College Students to Establish Residency, 2019")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_app2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Appendix 2. States Restricting Access to Postsecondary Education for Undocumented/DACA Students through April 2019")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_app3"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "viii",
      "id": "pg_viii",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Appendix 3. Cases Involving Citizens, Residency, Tuition Benefits/Status, and the DREAM Act & DACA (through April 2019)")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_app4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Appendix 4. Immigration-Related Issues: New York State Education Department Licenses")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_not"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("About the Author")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0